import React from "react";
import Button from "./UI/Button";
interface NotificationItemProps {
  id: string;
  content: string;
  date_time: Date;
  status: "read" | "unread";
  onDelete: (id: string) => void;
  onUpdate: (id: string) => void;
  onUpdateStatus: (id: string, status: "read" | "unread") => void;
  disabled?: boolean;
}
export const NotificationItem: React.FC<NotificationItemProps> = ({
  id,
  content,
  date_time,
  status,
  onDelete,
  onUpdate,
  onUpdateStatus,
  disabled,
}) => {
  const displayDate = date_time instanceof Date && !isNaN(date_time.getTime())
    ? date_time.toLocaleString("he-IL", {
      dateStyle: "short",
      timeStyle: "short",
    })
    : "תאריך לא תקין";
  const isUnread = status === "unread";
  return (
    <div className="bg-white shadow-card rounded-2xl p-4 mb-3 flex flex-col relative" dir="rtl">
      {isUnread && (
        <span
          className="absolute top-1/2 right-2 -translate-y-1/2 w-2 h-2 rounded-full border border-red-500 bg-transparent"
          aria-label="לא נקרא"
        ></span>
      )}
      <div className="flex justify-between items-start mb-3">
        <div className="text-base text-text-main text-right flex-1">{content}</div>
        <div className="text-sm text-gray-500 whitespace-nowrap ms-4">
          {displayDate}
        </div>
      </div>
      <div className="flex justify-start gap-2 mt-2">
        <Button
          variant="outline" 
          className={isUnread ? "border-green-600 text-green-600" : ""} 
          size="sm"
          onClick={() => onUpdateStatus(id, isUnread ? "read" : "unread")}
          disabled={disabled}
        >
          {isUnread ? "סמן כנקרא" : "סמן כלא נקרא"}
        </Button>

        <Button variant="outline" size="sm" onClick={() => onUpdate(id,)} disabled={disabled}>
          ערוך
        </Button>
        
        <Button variant="danger" size="sm" onClick={() => onDelete(id)} disabled={disabled}>
          מחק
        </Button>
      </div>
    </div>
  );
};

